<template>
  <a-modal
      title="库外专家录入须知"
      :width="960"
      :visible="visible"
      :maskClosable="false"
      @cancel="$emit('cancel')"
      :confirmLoading="loading"
      destroyOnClose
      :footer="null">
    <p style="text-indent: 2em">
      <span>第二十条 需选取专家的单位或专家管理机构在工作中发现专家库中无符合条件的专家，</span>
      <span>或符合条件的专家数量不够时，或经过三次以上随机抽取仍无法完成专家选取任务的，</span>
      <span>可以向市级以上的其他部门或者上级应急管理部门的专家库中选取或者指派具备条件的专家。</span>
    </p>
    <a-divider/>
    <div style="text-align: center">
      <a-space>
        <a-progress type="circle" :width="30"  :percent="per" />
        <a-button style="width: 150px" :disabled="isShow" type="primary" :loading="saveLoading" @click="onSubmit">{{showName}}</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ExternalPactModal',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {

  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      isShow: true,
      count: 10,
      times: null,
      showName: '确认看清须知',
      per: 0
    }
  },
  methods: {
    onStartLoadData () {
      this.count = 10
      this.per = 0
      this.isShow = true
      this.showName = '确认看清须知'
      this.timeStart()
    },
    onSubmit () {
      this.$emit('success')
    },
    timeStart () {
      this.times = setInterval(() => {
        this.seconds -= 1
        this.butTime()
      }, 500)
    },
    butTime () {
      this.count--
      this.per += 10
      if (this.count <= 0) {
        this.isShow = false
        this.showName = '前往录入'
        clearInterval(this.times)
      }
    }
  }
}
</script>

<style scoped>

</style>
